import React, { useState, useEffect, useRef } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import ButtonComponent from '../Button/Button';
import cn from 'classnames';
import styles from './Carousel.module.css';
import { HBox } from '../../../../components/Box';

function ImageCarouselComponent({ imgURLs, onDeleteImg, fullSize }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const thumbnailRefs = useRef([]);

  useEffect(() => {
    thumbnailRefs.current = thumbnailRefs.current.slice(0, imgURLs.length);
  }, [imgURLs]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (thumbnailRefs.current[activeIndex]) {
      thumbnailRefs.current[activeIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [activeIndex]);

  const handleSelect = (selectedIndex, e) => {
    setActiveIndex(selectedIndex);
  };

  const hasImages = imgURLs.length > 0;

  const renderPlaceholder = () => (
    <div className={styles.placeholder}>
      <div
        className={styles.img}
        style={{
          backgroundImage: "url('/public/images/placeholder.png')",
        }}
      ></div>
    </div>
  );

  const renderThumbnails = () => (
    <div className={styles.containerThumbnails}>
      <div className={styles.imageThumbnails} style={{ width: `${imgURLs.length * (100 + 10)}px` }}>
        {imgURLs.map((imageUrl, index) => (
          <img
            key={imageUrl.id}
            src={imageUrl.url}
            alt={imageUrl.type}
            className={cn(styles.thumbnail, { [styles.active]: index === activeIndex })}
            onClick={() => setActiveIndex(index)}
            ref={el => (thumbnailRefs.current[index] = el)}
          />
        ))}
      </div>
    </div>
  );
  const handleDelete = imageId => {
    onDeleteImg(imageId);
  };

  const controlStyles =
    imgURLs.length === 1
      ? `
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    display: none;
  }
`
      : `
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 3rem;
    height: 3rem;
    background-color: #0183D5;
    border-radius: 0.375rem;
  }
`;

  return (
    <>
      {hasImages ? (
        <>
          <Carousel
            indicators={false}
            className={styles.carousel}
            activeIndex={activeIndex}
            onSelect={handleSelect}
            interval={null}
            controls={imgURLs.length > 1}
          >
            {imgURLs.map((imageUrl, index) => (
              <Carousel.Item
                className={onDeleteImg || fullSize ? styles.carouselItemPadding : styles.carouselItem}
                key={imageUrl.id}
              >
                <HBox center>
                  <img className={cn('d-block w-100', styles.imgItem)} src={imageUrl.url} alt={imageUrl.type} />
                </HBox>
                {onDeleteImg && (
                  <div className={styles.buttonDelete}>
                    <ButtonComponent style={'ButtonSoftDelete'} onClick={() => handleDelete(imageUrl.id)}>
                      Delete
                    </ButtonComponent>
                  </div>
                )}
              </Carousel.Item>
            ))}
          </Carousel>

          {windowWidth >= 768 && renderThumbnails()}

          <style>{controlStyles}</style>
        </>
      ) : (
        renderPlaceholder()
      )}
    </>
  );
}

export default ImageCarouselComponent;
